import { createSlice } from "@reduxjs/toolkit";
import { cloneTheEstimate, downloadEstimate, fetchSeeMoreEstimate, generateROIReport, getCalculationData, getCustomer, getEstimate, getEstimateDetail, saveEstimate, stepperAPIAction, stepperAPIExisting, updateProductCombination, getPartnerCustomer, ConfirmUserTransfer, ListByUsers, UpdateUserAction, uploadGeneratedPdf } from "./action";
import { NEW_FIELDS } from "../constant/configurationConstant";

const initialState = {
    estimateList: [],
    estimateMessage: "",
    estimateType: "",
    estimateInfo: {
        state: 0, configId: 1, currencyValue: 1,
        currencySign: "$", currencyId: 1
    },
    assumptions: {},
    isEstimateLoader: false,
    calculationData: {},
    roiReport: {},
    seeMoreData: [],
    editPdfContent: "",
    currentStep: 0,
    customerList: [],
    currencyValue: 1,
    currencySign: "$",
    currencyId: 1,
    CurrencyListOption: [],
    estimatesType: "internal",
    globalUpdate: 0,
    isPending: false,
    resetFlag: false,
    optionsByUsers: [],
    isPdfGenerating: false,
    isPdfDownloading: false,
    pdfError: "",
    pdfDownloadLink: ""
} as any;

const getPdfErrorMessage = (payload: any, fallback: string) =>
    payload?.data?.message ?? payload?.message ?? fallback;
const isAnyOf =
    (...matchers: any) =>
        (action: any) =>
            matchers.some((matcher: any) =>
                typeof matcher === "string"
                    ? matcher === action.type
                    : matcher.type === action.type
            );

const estimateSlice = createSlice({
    name: 'estimate',
    initialState,
    reducers: {
        handleEstimateError: (state) => {
            state.estimateMessage = "";
            state.estimateType = "";
        },
        handleResetSeeMore: (state, action) => {
            state.seeMoreData = action.payload;
        },
        handleSetSeeMore: (state, action) => {
            state.seeMoreData = action.payload;
        },
        handleSavePdfContent: (state, action) => {
            state.editPdfContent = action.payload
            const tempdata = { ...state.calculationData, pdfPageContent: action.payload }
            state.calculationData = tempdata;
            state.estimateMessage = "PDF Template Successfully Saved!!!";
            state.estimateType = "success";
        },
        handleCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        handleCurrencyValue: (state, action) => {
            state.currencyValue = action.payload;

        },
        handleSign: (state, action) => {
            state.currencySign = action.payload;
        },
        handleUserType: (state, action) => {
            state.estimatesType = action.payload;
        },
        handleCurrencyList: (state, action) => {
            state.CurrencyListOption = action.payload;
        },
        handlePending: (state, action) => {
            state.isPending = action.payload;
        },
        handleResetFlag: (state, action) => {
            state.resetFlag = action.payload
        },
        handleResetEstimate: (state) => {
            state = {
                estimateList: [],
                estimateMessage: "",
                estimateType: "",
                estimateInfo: { state: 0, configId: 1 },
                assumptions: {},
                isEstimateLoader: false,
                calculationData: {},
                roiReport: {},
                seeMoreData: [],
                editPdfContent: "",
                currentStep: 0,
                customerList: [],
                estimatesType: state.estimatesType,
                isPending: state.isPending,
                isPdfGenerating: false,
                isPdfDownloading: false,
                pdfError: "",
                pdfDownloadLink: ""
            }
            return state;
        },
        handleResetEstimateInfo: (state) => {
            state = {
                estimateList: state.estimateList,
                estimateMessage: "",
                estimateType: "",
                estimateInfo: { state: 0, configId: 1 },
                assumptions: {},
                isEstimateLoader: false,
                calculationData: {},
                roiReport: {},
                seeMoreData: state.seeMoreData,
                editPdfContent: "",
                currentStep: 0,
                customerList: [],
                estimatesType: state.estimatesType,
                isPending: state.isPending,
                isPdfGenerating: false,
                isPdfDownloading: false,
                pdfError: "",
                pdfDownloadLink: ""
            }
            return state;
        }
    },
    extraReducers: (builder) => builder
        .addCase(getEstimate.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.estimateList = payload.data.data;
                state.estimateInfo = {};
                state.roiReport = {};
            }
            return state;
        })
        .addCase(getCustomer.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.customerList = payload.data.data.map((customer: any) => ({
                    Id: customer.Id,
                    Name: customer.Name,
                }));
            }
            return state;
        })
        .addCase(getPartnerCustomer.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.customerList = payload.data.data
            }
            return state;
        })
        .addCase(stepperAPIAction.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(UpdateUserAction.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(stepperAPIExisting.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(getEstimateDetail.fulfilled, (state, { payload }) => {
            state.isEstimateLoader = false;
            if (payload.status === 200) {
                const { data } = payload.data;
                if (data && data?.estimateNew) {
                    state.globalUpdate = data?.estimateNew && data['estimateNew']?.state
                }
                state.estimateInfo = {
                    ...data,
                    estimateId: data[NEW_FIELDS]?.id ?? data?.id
                };
                state.assumptions = payload.data.assumptions;
                const customerData = data[NEW_FIELDS]?.customerInfo ?? data?.customerInfo;
                state.customerList = [{ ...customerData }];
            }
            return state;
        })
        .addCase(getCalculationData.fulfilled, (state, { payload }) => {
            state.isEstimateLoader = false;
            if (payload.status === 200) {
                state.calculationData = payload.data.data;
                state.editPdfContent = payload?.data?.pdfPageContent


                state.assumptions = payload.data.assumptions;
            }
            return state;
        })
        .addCase(saveEstimate.fulfilled, (state, { payload }) => {
            if (payload.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(generateROIReport.pending, (state) => {
            state.isPdfGenerating = true;
            state.pdfError = "";
        })
        .addCase(generateROIReport.fulfilled, (state, { payload }) => {
            state.isPdfGenerating = false;
            if (payload?.status === 200) {
                state.roiReport = payload.data.data;
            }
            return state;
        })
        .addCase(generateROIReport.rejected, (state, { payload }) => {
            state.isPdfGenerating = false;
            state.pdfError = getPdfErrorMessage(payload, "Unable to generate the ROI report.");
            state.estimateMessage = state.pdfError;
            state.estimateType = "error";
        })
        .addCase(uploadGeneratedPdf.pending, (state) => {
            state.isPdfGenerating = true;
            state.pdfError = "";
        })
        .addCase(uploadGeneratedPdf.fulfilled, (state, { payload }) => {
            state.isPdfGenerating = false;
            state.pdfDownloadLink = payload?.data?.data?.link ?? "";
        })
        .addCase(uploadGeneratedPdf.rejected, (state, { payload }) => {
            state.isPdfGenerating = false;
            state.pdfError = getPdfErrorMessage(payload, "Unable to save the generated PDF.");
            state.estimateMessage = state.pdfError;
            state.estimateType = "error";
        })
        .addCase(cloneTheEstimate.fulfilled, (state, { payload }) => {

            if (payload?.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            if (payload.status === 422) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "error";
            }
            return state;
        })
        .addCase(downloadEstimate.pending, (state) => {
            state.isPdfDownloading = true;
            state.pdfError = "";
        })
        .addCase(downloadEstimate.fulfilled, (state, { payload }) => {
            state.isPdfDownloading = false;
            state.pdfDownloadLink = payload?.data?.data?.link ?? "";
            if (payload?.status === 422) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "info";
            }
            return state;
        })
        .addCase(downloadEstimate.rejected, (state, { payload }) => {
            state.isPdfDownloading = false;
            state.pdfError = getPdfErrorMessage(payload, "Unable to download the ROI report.");
            state.estimateMessage = state.pdfError;
            state.estimateType = "error";
        })
        .addCase(fetchSeeMoreEstimate.fulfilled, (state, { payload }) => {
            const payloads = payload.data.data.rows ?? payload.data.data
            if (payload.status === 200) {
                state.seeMoreData = [...state.seeMoreData, ...payloads];
            }
            if (payload.status === 422) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "info";
            }
            return state;
        })
        .addCase(updateProductCombination.fulfilled, (state, { payload }) => {
            if (payload?.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(ConfirmUserTransfer.fulfilled, (state, { payload }) => {
            state.isEstimateLoader = false;
            if (payload.status === 200) {
                state.estimateMessage = payload.data.message;
                state.estimateType = "success";
            }
            return state;
        })
        .addCase(ListByUsers.fulfilled, (state, { payload }) => {
            state.isConfigLoader = false;
            if (payload.status === 200) {
                const rows = payload?.data?.data?.rows ?? [];
                const formatted = rows
                    ?.filter((u: any) => u?.isOnBoarded === true)
                    ?.map((u: any) => ({
                        id: u.userId,
                        label: `${u.firstName} ${u.lastName}`,
                        email: u.userEmail,
                        role: u.roles?.name,
                    })) ?? [];

                state.optionsByUsers = formatted;
            }
            return state;
        })
        .addMatcher(isAnyOf(getEstimateDetail.pending), (state) => {
            return {
                ...state,
                isEstimateLoader: true
            };
        })
});

export const { handleUserType, handleEstimateError, handleResetSeeMore, handleSetSeeMore, handleSavePdfContent, handleCurrentStep, handleResetEstimate, handleResetEstimateInfo, handleCurrencyValue, handleSign, handleCurrencyList, handlePending, handleResetFlag } = estimateSlice.actions;

export default estimateSlice.reducer;
